import {getObject,postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi'; 
import {IMerchantKeyInformation,IPatientCreditCard,IPaySimpleCardRequest,IPaySimpleSubmission,IPaySimpleCardInactivate,IPaySimple3DS, ICreditCardData} from '../Models/PaySimple/PaySimpleCreditCardModel';
import {IRecurringPaymentList,IProcessedPayment} from '../../lib/Models/PaymentPlanProcessModel';


export enum ErrorReturnMessage {
    merchant = "Unable to obtain merchant ID", 
    patientCards = "Unable to obtain a list of patient credit cards",
    submitCards = "Unable to submit credit card information",
    removeCard = "Unable to remove credit card",
    recurringPayments = "Unable to execute recurring payments"
};

export async function getMerchantKey(): Promise<IResultAndError<IMerchantKeyInformation>>{ 
    let returnErrorMessage = "";
    const url = `api/CreditCard/PaySimple/GetMerchantKey`; 
    const responseObject = await getObject<IMerchantKeyInformation>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.merchant;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}
export async function getPatientCards(patientId: number): Promise<IResultAndError<IPatientCreditCard[]>>{  
    let returnErrorMessage = "";
    const url = `api/CreditCard/PaySimple/GetPatientCards/${patientId}`; 
    const responseObject = await getObject<IPatientCreditCard[]>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.patientCards;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
} 
export async function submitPaySimpleCard(payload: IPaySimpleCardRequest): Promise<IResultAndError<IPaySimpleSubmission>>{
    return postObjectWithApiError("api/CreditCard/PaySimple/SubmitPaySimpleCard", payload);
}; 
export async function removePaySimpleCard(payload: IPaySimpleCardInactivate): Promise<IResultAndError<IPaySimpleSubmission>>{
    return postObjectWithApiError("api/CreditCard/PaySimple/InactivatePaySimpleCard", payload);
}; 
export async function RecurringPayments(payload: IRecurringPaymentList): Promise<IResultAndError<IProcessedPayment[]>>{
    return postObjectWithApiError("api/CreditCard/PaySimple/RecurringPayments", payload);
};
export async function submitPaySimpleCard3DS(payload: IPaySimple3DS): Promise<IResultAndError<IPaySimpleSubmission>>{
    return postObjectWithApiError("api/CreditCard/PaySimple/SubmitPaySimpleCard3DS", payload);
}; 

export async function getInactiveCreditCards(patientId: number): Promise<ICreditCardData[] | undefined>{
    return getObject<ICreditCardData[]>(`api/CreditCard/PaySimple/InactiveCards/${patientId}`);
}; 